import React from 'react'
import { TextField as MuiTextField, TextFieldProps as MuiTextFieldProps } from '@mui/material'
import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

type Props<FormValues extends FieldValues = FieldValues> = MuiTextFieldProps & UseControllerProps<FormValues>

// eslint-disable-next-line prefer-arrow-callback
/** @TODO: Handle missing FormProvider error: https://github.com/react-hook-form/react-hook-form/discussions/5150  */
export const MuiRhfTextFieldInputRef = React.forwardRef(function MuiRhfTextFieldRef<
    FormValues extends FieldValues = FieldValues,
>(
    { name, control, defaultValue, rules, shouldUnregister, ...textFieldProps }: Props<FormValues>,
    _ref: React.ForwardedRef<HTMLDivElement>, // Warning: Did you forget to use the ref parameter,
) {
    const {
        field: { value, ...rhfFieldProps },
        fieldState: {
            // invalid,
            // isTouched,
            // isDirty,
            error,
        },
    } = useController<FormValues>({
        name,
        control,
        defaultValue,
        rules,
        shouldUnregister,
    })

    const errorMessage = error ? error.message || '' : undefined

    // use current value of field for optional dynamic input
    const helperText = textFieldProps.helperText
        ? React.isValidElement(textFieldProps.helperText)
            ? React.cloneElement(textFieldProps.helperText, { value } as any)
            : textFieldProps.helperText
        : textFieldProps.helperText || errorMessage

    return (
        <MuiTextField
            {...rhfFieldProps}
            {...textFieldProps}
            onChange={(e) => {
                rhfFieldProps.onChange(e)
                textFieldProps.onChange?.(e)
                // handleOnValidate(e)
            }}
            onBlur={(e) => {
                rhfFieldProps.onBlur()
                textFieldProps.onBlur?.(e)
                // handleOnValidate(e)
            }}
            value={value || ''}
            required={textFieldProps.required || !!rules?.required}
            error={textFieldProps.error || !!error}
            helperText={helperText}
        />
    )
})

export default MuiRhfTextFieldInputRef
export { MuiRhfTextFieldInputRef as MuiRhfTextField, MuiRhfTextFieldInputRef as TextField }
export type { Props as TextFieldProps, Props as MuiRhfTextFieldProps }
